import { CheckboxState, CombinationType, Corridore } from 'features/virtual/types';
import {
  VirtualTemplateAvvenimentoCorse,
  VirtualTemplateAvvenimentoResponseApi,
} from 'lib/api/virtual/virtualTemplateAvvenimentoApi';

import { formatKey } from 'features/virtual/utils/functions';

type newCheckboxesStatesType = {
  state: Array<Array<CheckboxState>>;
  indexRowSelected: number;
  indexButtonSelected: number;
  checked: boolean;
  disabled: boolean;
};

export const retrieveActionTypes = () => {
  return {
    // SET
    SET_SCOMMESSA_IN_ORDINE_STATES: 'SET_SCOMMESSA_IN_ORDINE_STATES',
    SET_SCOMMESSA_IN_DISORDINE_STATES: 'SET_SCOMMESSA_IN_DISORDINE_STATES',
    SET_SCOMMESSA_COMBINATION: 'SET_SCOMMESSA_COMBINATION',
    SET_SCOMMESSA_DISABLE: 'SET_SCOMMESSA_DISABLE',
    SET_KEY_SCOMMESSA: 'SET_KEY_SCOMMESSA',
    // UPDATE
    UPDATE_SCOMMESSA_IN_ORDINE_STATES: 'UPDATE_SCOMMESSA_IN_ORDINE_STATES',
    UPDATE_SCOMMESSA_IN_DISORDINE_STATES: 'UPDATE_SCOMMESSA_IN_DISORDINE_STATES',
    UPDATE_SCOMMESSA_IN_ORDINE_COMBINATION: 'UPDATE_IN_ORDINE_SCOMMESSA',
    UPDATE_SCOMMESSA_IN_DISORDINE_COMBINATION: 'UPDATE_SCOMMESSA_IN_DISORDINE_COMBINATION',
    // FILTER
    FILTER_SCOMMESSA_COMBINATION: 'FILTER_SCOMMESSA_COMBINATION',

    //RESET
    RESET_SCOMMESSA_COMBINATION: 'RESET_SCOMMESSA_COMBINATION',
    RESET_SCOMMESSA_IN_ORDINE_STATES: 'RESET_SCOMMESSA_IN_ORDINE_STATES',
    RESET_SCOMMESSA_IN_DISORDINE_STATES: 'RESET_SCOMMESSA_IN_DISORDINE_STATES',
    RESET_KEY_SCOMMESSA: 'RESET_KEY_SCOMMESSA',
  };
};

export const retrieveStatesKeys = () => {
  return {
    ACCOPPIATA_IN_ORDINE_STATES: 'accoppiataInOrdineStates',
    TRIO_IN_ORDINE_STATES: 'trioInOrdineStates',
    ACCOPPIATA_IN_DISORDINE_STATES: 'accoppiataInDisordineStates',
    TRIO_IN_DISORDINE_STATES: 'trioInDisordineStates',

    ACCOPPIATA_IN_ORDINE_DISABLE: 'accoppiataInOrdineDisabled',
    TRIO_IN_ORDINE_DISABLE: 'trioInOrdineDisabled',
    ACCOPPIATA_IN_DISORDINE_DISABLE: 'accoppiataInDisordineDisabled',
    TRIO_IN_DISORDINE_DISABLE: 'trioInDisordineDisabled',

    COMBINATION_ACCOPPIATA_IN_ORDINE: 'combinationAccoppiataInOrdine',
    COMBINATION_TRIO_IN_ORDINE: 'combinationTrioInOrdine',

    COMBINATION_ACCOPPIATA_IN_DISORDINE: 'combinationAccoppiataInDisordine',
    COMBINATION_TRIO_IN_DISORDINE: 'combinationTrioInDisordine',
  };
};

export const retrieveNewCheckboxStates = ({
  state,
  indexRowSelected,
  indexButtonSelected,
  checked,
  disabled,
}: newCheckboxesStatesType) => {
  state[indexRowSelected][indexButtonSelected] = {
    checked: checked,
    disabled: state[indexRowSelected][indexButtonSelected].disabled,
  };
  state.forEach((rowCheckbox, indexRowCheckbox) => {
    if (indexRowCheckbox !== indexRowSelected) {
      rowCheckbox.forEach((checkbox, indexCheckbox) => {
        if (indexCheckbox === indexButtonSelected) {
          checkbox.disabled = disabled;
        }
      });
    } else {
      rowCheckbox.forEach((checkbox, indexCheckbox) => {
        if (indexCheckbox !== indexButtonSelected) {
          checkbox.disabled = disabled;
        }
      });
    }
  });
  return state;
};

export const dictionaryKeys = {
  [retrieveStatesKeys().COMBINATION_ACCOPPIATA_IN_ORDINE]: [
    retrieveStatesKeys().ACCOPPIATA_IN_DISORDINE_DISABLE,
    retrieveStatesKeys().TRIO_IN_DISORDINE_DISABLE,
    retrieveStatesKeys().TRIO_IN_ORDINE_DISABLE,
  ],
  [retrieveStatesKeys().COMBINATION_TRIO_IN_ORDINE]: [
    retrieveStatesKeys().ACCOPPIATA_IN_DISORDINE_DISABLE,
    retrieveStatesKeys().TRIO_IN_DISORDINE_DISABLE,
    retrieveStatesKeys().ACCOPPIATA_IN_ORDINE_DISABLE,
  ],
  [retrieveStatesKeys().COMBINATION_ACCOPPIATA_IN_DISORDINE]: [
    retrieveStatesKeys().ACCOPPIATA_IN_ORDINE_DISABLE,
    retrieveStatesKeys().TRIO_IN_DISORDINE_DISABLE,
    retrieveStatesKeys().TRIO_IN_ORDINE_DISABLE,
  ],
  [retrieveStatesKeys().COMBINATION_TRIO_IN_DISORDINE]: [
    retrieveStatesKeys().ACCOPPIATA_IN_ORDINE_DISABLE,
    retrieveStatesKeys().ACCOPPIATA_IN_DISORDINE_DISABLE,
    retrieveStatesKeys().TRIO_IN_ORDINE_DISABLE,
  ],
};

export const dictionaryCombinationTypes = {
  [CombinationType.ACCOPPIATA_IN_ORDINE]: {
    keyState: retrieveStatesKeys().ACCOPPIATA_IN_ORDINE_STATES,
    keyCombination: retrieveStatesKeys().COMBINATION_ACCOPPIATA_IN_ORDINE,
    type: CombinationType.ACCOPPIATA_IN_ORDINE,
  },
  [CombinationType.TRIO_IN_ORDINE]: {
    keyState: retrieveStatesKeys().TRIO_IN_ORDINE_STATES,
    keyCombination: retrieveStatesKeys().COMBINATION_TRIO_IN_ORDINE,
    type: CombinationType.TRIO_IN_ORDINE,
  },
  [CombinationType.ACCOPPIATA_IN_DISORDINE]: {
    keyState: retrieveStatesKeys().ACCOPPIATA_IN_DISORDINE_STATES,
    keyCombination: retrieveStatesKeys().COMBINATION_ACCOPPIATA_IN_DISORDINE,
    type: CombinationType.ACCOPPIATA_IN_DISORDINE,
  },
  [CombinationType.TRIO_IN_DISORDINE]: {
    keyState: retrieveStatesKeys().TRIO_IN_DISORDINE_STATES,
    keyCombination: retrieveStatesKeys().COMBINATION_TRIO_IN_DISORDINE,
    type: CombinationType.TRIO_IN_DISORDINE,
  },
};

export const dictionaryActionDispatches = {
  [CombinationType.ACCOPPIATA_IN_ORDINE]: {
    filter: retrieveActionTypes().FILTER_SCOMMESSA_COMBINATION,
    reset: retrieveActionTypes().RESET_SCOMMESSA_COMBINATION,
    key: retrieveStatesKeys().COMBINATION_ACCOPPIATA_IN_ORDINE,
  },
  [CombinationType.TRIO_IN_ORDINE]: {
    filter: retrieveActionTypes().FILTER_SCOMMESSA_COMBINATION,
    reset: retrieveActionTypes().RESET_SCOMMESSA_COMBINATION,
    key: retrieveStatesKeys().COMBINATION_TRIO_IN_ORDINE,
  },
  [CombinationType.ACCOPPIATA_IN_DISORDINE]: {
    filter: retrieveActionTypes().FILTER_SCOMMESSA_COMBINATION,
    reset: retrieveActionTypes().RESET_SCOMMESSA_COMBINATION,
    key: retrieveStatesKeys().COMBINATION_ACCOPPIATA_IN_DISORDINE,
  },
  [CombinationType.TRIO_IN_DISORDINE]: {
    filter: retrieveActionTypes().FILTER_SCOMMESSA_COMBINATION,
    reset: retrieveActionTypes().RESET_SCOMMESSA_COMBINATION,
    key: retrieveStatesKeys().COMBINATION_TRIO_IN_DISORDINE,
  },
};

export const reorderListScommessaByPosFinale = (list: Array<Corridore>) => {
  if (list.some((item) => +item.posFinale > 1)) {
    return list.sort((a, b) => +a.posFinale - +b.posFinale);
  }
  return list;
};

export const handlerscommessaKey = (list: Array<Corridore>, combinationType: CombinationType) => {
  const { keyAvvenimento } = list[0];
  let idEsito;
  let listSorted;
  switch (combinationType) {
    case CombinationType.ACCOPPIATA_IN_ORDINE:
      listSorted = reorderListScommessaByPosFinale(list);
      idEsito = listSorted[0].posPartenza + '-' + listSorted[1].posPartenza;
      return keyAvvenimento + '_' + idEsito;
    case CombinationType.TRIO_IN_ORDINE:
      listSorted = reorderListScommessaByPosFinale(list);
      idEsito = listSorted[0].posPartenza + '-' + listSorted[1].posPartenza + '-' + listSorted[2].posPartenza;
      return keyAvvenimento + '_' + idEsito;
    case CombinationType.ACCOPPIATA_IN_DISORDINE:
      listSorted = sortListHandler(list);
      idEsito = listSorted[0].posPartenza + '-' + listSorted[1].posPartenza;
      return keyAvvenimento + '_' + idEsito;
    case CombinationType.TRIO_IN_DISORDINE:
      listSorted = sortListHandler(list);
      idEsito = listSorted[0].posPartenza + '-' + listSorted[1].posPartenza + '-' + listSorted[2].posPartenza;
      return keyAvvenimento + '_' + idEsito;

    default:
      throw new Error('combination type is not found');
  }
};

export const resetscommessaKey = () => {
  return '';
};

export const sortListHandler = (list: Array<Corridore>) => {
  return list.sort((a, b) => +a.posPartenza - +b.posPartenza);
};

const findTipoScommessa = (combinationType: CombinationType, quoteList) => {
  switch (combinationType) {
    case CombinationType.ACCOPPIATA_IN_ORDINE:
      return quoteList[0].codiceTipoScommessa;
    case CombinationType.TRIO_IN_ORDINE:
      return quoteList[1].codiceTipoScommessa;
    case CombinationType.ACCOPPIATA_IN_DISORDINE:
      return quoteList[2].codiceTipoScommessa;
    case CombinationType.TRIO_IN_DISORDINE:
      return quoteList[3].codiceTipoScommessa;
    default:
      throw new Error();
  }
};

export const createCombinationList = (
  virtualAvvenimento: (VirtualTemplateAvvenimentoResponseApi & VirtualTemplateAvvenimentoCorse) | undefined,
  combinationList: Array<number>,
  combinationType: CombinationType
) => {
  if (virtualAvvenimento && virtualAvvenimento.faiLaTuaGiocata) {
    return virtualAvvenimento.faiLaTuaGiocata?.reduce<Array<Array<Corridore>>>((acc, giocata) => {
      const arrayGiocata = combinationList.map((value) => ({
        id: formatKey([giocata.nome, `${giocata.posizionePartenza}`, `${value}`]),
        posPartenza: giocata.posizionePartenza.toString(),
        posFinale: value.toString(),
        keyAvvenimento: formatKey([
          virtualAvvenimento.idProgramma,
          virtualAvvenimento.idAvvenimento,
          findTipoScommessa(combinationType, virtualAvvenimento.quoteCombinateList),
        ]),
        codiceTipoScommessa: findTipoScommessa(combinationType, virtualAvvenimento.quoteCombinateList),
      }));
      return [...acc, arrayGiocata];
    }, []);
  } else {
    return [[]];
  }
};

export const createCheckboxList = (
  virtualAvvenimento: (VirtualTemplateAvvenimentoResponseApi & VirtualTemplateAvvenimentoCorse) | undefined,
  checkBoxType: CombinationType
): Array<Corridore> => {
  if (virtualAvvenimento && virtualAvvenimento.faiLaTuaGiocata) {
    return virtualAvvenimento.faiLaTuaGiocata?.map((singleItem) => {
      return {
        id: formatKey([checkBoxType, singleItem.nome]),
        value: singleItem.nome,
        posPartenza: singleItem.posizionePartenza.toString(),
        posFinale: '0',
        codiceTipoScommessa: findTipoScommessa(checkBoxType, virtualAvvenimento.quoteCombinateList)!,
        keyAvvenimento: formatKey([
          virtualAvvenimento.idProgramma,
          virtualAvvenimento.idAvvenimento,
          findTipoScommessa(checkBoxType, virtualAvvenimento.quoteCombinateList),
        ]),
      } as Corridore;
    });
  } else {
    return [];
  }
};
